// Stripe Redirect Controller
//
// Used by the /seller/payments/stripe_loading page. Fetches the Stripe
// URL from a JSON endpoint and redirects when it arrives. The loading
// page itself shows a spinner so the user isn't staring at a blank tab.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { fetchUrl: String }

  connect() {
    this.fetchAndRedirect()
  }

  async fetchAndRedirect() {
    const response = await fetch(this.fetchUrlValue, {
      headers: { "Accept": "application/json" }
    })
    if (!response.ok) return  // browser surfaces the error
    const data = await response.json()
    if (data.url) window.location.replace(data.url)
  }
}
